var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2368a7177dfa801234fc9db0f201e2e1dd82f06c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lifeworkcalendar@reclaimai"]={id:"2368a7177dfa801234fc9db0f201e2e1dd82f06c"};
      